import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { jsPDF } from "jspdf";
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

import { LoanService } from "../../shared/loan.service";
import { environment } from '../../../../environments/environment';

import { Loan } from "../loan";

@Injectable({
  providedIn: 'root'
})
export class PrintddfundService {

  LoanApprovedStatus: number = 0;  // status for approved or not.
  DDFundList: any[] = [];
  public selectedLoan: Loan;

  constructor(private httpClient: HttpClient,
    private loanService: LoanService, public datePipe: DatePipe,) {}

    getBaseUrl() {
      return environment.baseUrl;
    }

    GetDDFundList(rptSearchData: any) {

    this.FetchDDFundList(rptSearchData)
      .toPromise()
      .then(data => {

        if (data.length > 0) {
          this.ReportGenerateList(data, this.datePipe);
      }
      else {
        console.log('data not found!');
      }
      })
      .catch(err => { console.log(err) });
    }

  FetchDDFundList(rptSearchData: any) {
    this.selectedLoan = new Loan();
    this.selectedLoan.ReportName = rptSearchData.ReportName;
    this.selectedLoan.ToDate = rptSearchData.LoanToDate;
    this.selectedLoan.BranchId = rptSearchData.BranchId;
    this.selectedLoan.CentreId = rptSearchData.CentreId;

    this.selectedLoan.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedLoan.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedLoan.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedLoan.SaasId = + JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];

    let body = this.selectedLoan;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Loan/Report', body, { headers: headers });
  }


  //--------------------------------------------------
  // Printing the documents as a lists.  
  ReportGenerateList(DDFundList,datePipe: DatePipe) {

    var generateData = function (DDFundList) {

      var result = [];
      var itemData = [{}];
      // let todayDate = new Date(); 
      // console.log(datePipe.transform(todayDate, 'yyyy-MM-dd'));

      for (var i = 0; i < DDFundList.length; i += 1) {
        itemData[i] = {
          Id: DDFundList[i].Id.toString(),      
          'Customer': DDFundList[i].CustomerName.toString(),
          'Loan No.': DDFundList[i].LoanNumber.toString(),
          'Loan Date': datePipe.transform(DDFundList[i].LoanApprovedDate, 'dd-MM-yyyy').toString(),
          'DD Fund':  DDFundList[i].DDFund.toString(),  
          'GF':  DDFundList[i].GFAmount.toString(),  
          'Total': ((DDFundList[i].DDFund * 1) +  (DDFundList[i].GFAmount * 1)).toString(),
        };
      }

      // 'Date': datePipe.transform(DDFundList[i].LoanApprovedDate, 'dd-MM-yyyy'),
      for (var i = 0; i < DDFundList.length; i += 1) {
        itemData[i]['Id'] = (i + 1).toString();
        result.push(Object.assign({}, itemData[i]));
      }

      return result;
    };


    function createHeaders(HeaderName) {

      var HeaderResult = [];
      for (var i = 0; i < HeaderName.length; i += 1) {
        HeaderResult.push({
          id: HeaderName[i],
          name: HeaderName[i],
          prompt: HeaderName[i],
          width: 100,
          align: "left",
          padding: 0,
        });
      }
      return HeaderResult;
    }

    var headers = createHeaders([
      "Id",
      "Customer",
      "Loan No.",
      "Loan Date",
      "DD Fund",
      "GF",
      "Total",
    ]);
  
    // let pdf = new jsPDF('l', 'pt', 'letter');
    let pdf = new jsPDF('p', 'pt', 'A4');  

    pdf.setProperties({
      title: 'DD Fund',
      subject: 'Info about PDF',
      author: 'PDFAuthor',
      keywords: 'generated, javascript, web 2.0, ajax',
      creator: 'SRI'
    });
    
    let todayDate = new Date(); 

    // Top HEADER
    pdf.setTextColor(0, 0, 0);
    pdf.setFontSize(14);
    pdf.setFont('arial', 'normal');
    pdf.text("Society For Rural Improvements", 210, 40);  // 40 is the height
    pdf.text("DD Fund Sheet", 245, 60);
    pdf.text("Statement on  " +  datePipe.transform(todayDate, 'dd-MM-yyyy'), 225, 80);
    pdf.setLineWidth(1.5);
    pdf.line(5, 105, 590, 105)
    // Top HEADER END 

    // Second Top HEADER
    pdf.setFontSize(10);
    pdf.setFont('arial', 'normal');
    pdf.text("BRANCH NAME	: " + DDFundList[0].CustomerBranchName.toString(), 25, 120);
    pdf.text("CENTRE NAME	: " + DDFundList[0].CentreName.toString(), 25, 140);
    pdf.text("TOTAL MEMBERS : " + DDFundList.length.toString() ,  25, 160);
    pdf.text("CENTRE MANAGER :" + DDFundList[0].GroupLeaderName.toString(), 400, 120);
    pdf.text("BRANCH PHONE :" + DDFundList[0].BranchPhone.toString(), 400, 140);
    //pdf.text("BANK DETAIL	 :" + '', 400, 160);
    // pdf.text("Date :" + datePipe.transform(todayDate, 'dd-MM-yyyy'), 400, 180);
   	
    pdf.line(5, 165, 590, 165)   // x-axis, -x-axix,  y-axis  , -y-axix
    // Top HEADER END 

    // Body
    pdf.table(10, 175, generateData(DDFundList), headers, { autoSize: false });
    pdf.output('dataurlnewwindow');
    // Body End
  }

}

